// ====================states page=================
import florida from './state/Florida.json';
import Massachusts from './state/Massachusetts.json';
import Texas from './state/texas.json';
import California from './state/California.json';
import Newjersey from './state/New_Jersey.json';
import Newyork from './state/New_York.json';
import Illinois from './state/Illinois.json';
import ConnectiCut from './state/Connecticut.json';
import Pennsylvania from './state/Pennsylvania.json';
import GeorGia from './state/Georgia.json';
import ColoradoSt from './state/ColoradoState.json';

// ====================airport page=================
import Miami from './airport-page/miami.json';
import FortLauderdale from './airport-page/fortlauderdale.json';
import TampaInternational from './airport-page/tampa-international.json';
import SouthWestFlorida from './airport-page/southwest-florida.json';
import Orlando from './airport-page/Orlando.json';
import Logan from './airport-page/logan.json';
import DallasLove from './airport-page/dallas-love.json';
import DallasFortWorth from './airport-page/dallas-fort-worth.json';
import FortWorthalia from './airport-page/fort-worth-alliance.json';
import dallasexecutive from './airport-page/dallas-executive-airport.json';
import SanFranciso from './airport-page/san-francisco.json';
import Oaklandairport from './airport-page/oakland-airport.json';
import SanJOse from './airport-page/san-jose.json';
import Newark from './airport-page/newark-liberty.json';
import Jfkairport from './airport-page/jfk-airport.json';
import Lgaairport from './airport-page/laGuardia-airport.json';
import LongIsland from './airport-page/longLand.json';
import RonaldReagan from './airport-page/ronald-reagan.json';
import washingtonDulles from './airport-page/washingto-dulles.json';
import Baltimore from './airport-page/balti-more.json';
import Ohare from './airport-page/o-hare.json';
import Midway from './airport-page/midway-airport.json';
import Bradly from './airport-page/Bradley-airport.json';
import PhiladelPhiaAirport from './airport-page/philadelphia.json';
import HartField from './airport-page/hartsfield-airport.json';
import DenverAirport from './airport-page/danver-airport.json';
import HoustonAirport from './airport-page/houston.json';
import AustinAirport from './airport-page/austin.json';
// ================location cities page ============
import CitiesMiami from './cities/miami.json';
import CitiesBoston from './cities/boston.json';
import Citiesdallas from './cities/dallas.json';
import Citieorlando from './cities/orlando.json';
import Citiesfort from './cities/fort.json';
import CitiesfortWorth from './cities/fort-worth.json';
import Samfranciso from './cities/san-francisco.json';
import JersyCity from './cities/new-jersy.json';
import NewYork from './cities/newYork.json';
import WashingtonCity from './cities/washington-Dc.json';
import chicagoCity from './cities/chicago.json';
import HartFord from './cities/hartford.json';
import PhiladelPhia from './cities/philadelphia-city.json';
import AtlantaCity from './cities/atlanta.json';
import FortMayers from './cities/FortMayers.json';
import DanverCity from './cities/danveer.json';
import Huston from './cities/huston.json';
import AustinCity from './cities/austinCity.json';

// =================New City Page ================

// ===================services page=======================

import Carservice from './Servies/car_service.json';
import ChauffourServices from './Servies/chauffeur_service.json';
import CityToCity from './Servies/city_to_city.json';
import Hourlyhire from './Servies/hour_hire.json';
import PointtoPoint from './Servies/point_to_point.json';
import ClientPartner from './Servies/b-service/client_partner.json';
import CorprateEvent from './Servies/b-service/corporate_event.json';
import CorprateAirport from './Servies/b-service/corporate_airport.json';
import Meetingoffsite from './Servies/b-service/offsite_event.json';
// ===================Roputes page=======================
import OrlandoDisneyWorld from '@/app/data/demo/OrlandoDisneyWorld.json';
import OrlandoTampa from '@/app/data/demo/OrlandoTampa.json';
import OrlandoUniversalStudio from '@/app/data/demo/OrlandoUniversalStudio.json';
import OrlandoPortCanaveral from '@/app/data/demo/OrlandoPortCanaveral.json';
import OrlandoPalmBeach from '@/app/data/demo/OrlandoPalmBeach.json';
import MiamiPalmBeach from '@/app/data/demo/MiamiPalmBeach.json';
import FortLauderdaleOrlando from '@/app/data/demo/FortLauderdaleOrlando.json';
import BostonNewYork from '@/app/data/demo/BostonNewYork.json';
import BostonProvinceTown from '@/app/data/demo/BostonProvinceTown.json';
import NewHevanBoston from '@/app/data/demo/NewHevanBoston.json';
import BostonCapeCod from '@/app/data/demo/BostonCapeCod.json';
import BostonHyannis from '@/app/data/demo/BostonHyannis.json';
import BostonBarnstable from '@/app/data/demo/BostonBarnstable.json';
import BostonFalmouth from '@/app/data/demo/BostonFalmouth.json';
import AustinDallas from '@/app/data/demo/AustinDallas.json';
import SanFranciscoNapa from '@/app/data/demo/SanFranciscoNapa.json';
import SanFranciscoCarmel from '@/app/data/demo/SanFranciscoCarmel.json';
import NewYorkAtlanticCity from '@/app/data/demo/NewYorkAtlanticCity.json';
import MiamiOrlando from '@/app/data/demo/MiamiOrlando.json';
import MiamiFortLauderdale from '@/app/data/demo/MiamiFortLauderdale.json';
import FortPalmBeach from '@/app/data/demo/FortPalmBeach.json';
import FortLauderdaleTampa from '@/app/data/demo/FortLauderdaleTampa.json';
import NYCWashingtonDC from '@/app/data/demo/NYCWashingtonDC.json';
import NYCNewHaven from '@/app/data/demo/NYCNewHaven.json';
import NYCEastHampton from '@/app/data/demo/NYCEastHampton.json';
import NYCMontauk from '@/app/data/demo/NYCMontauk.json';
import NYCGreenwichCT from '@/app/data/demo/NYCGreenwichCT.json';
import NYCGreenport from '@/app/data/demo/NYCGreenport.json';
import NYCPhiladelphia from '@/app/data/demo/NYCPhiladelphia.json';
import WashingtonDCBaltimore from '@/app/data/demo/WashingtonDCBaltimore.json';
import ChicagoMilwaukee from '@/app/data/demo/ChicagoMilwaukee.json';
import PhiladelphiaAtlanticCity from '@/app/data/demo/PhiladelphiaAtlanticCity.json';
import SaintTropez from '@/app/data/demo/SaintTropez.json';
import HartFordBoston from '@/app/data/demo/hartford-boston.json';
import AltanticNadhvil from '@/app/data/demo/AltanticNashvil.json';
import DenverVail from '@/app/data/demo/danveerVail.json';
import DenverCopper from '@/app/data/demo/danverCopper.json';
import DenverBreck from '@/app/data/demo/danverBreckenridge.json';
import DenverAspen from '@/app/data/demo/denverAspen.json';
import DenverBeaver from '@/app/data/demo/danverbeaver.json';
import DenverSnow from '@/app/data/demo/danverSnowmass.json';
// ===================blogs page here ==============
import FirstBLog from './blog/first.json';
import SecondtBLog from './blog/second.json';
import WhyBussines from './blog/whyBussiness.json';
const statesPage = [
  {
    title: '1',
    link: 'car-service-florida',
    data: florida,
  },

  {
    title: '2',
    link: 'car-service-massachusetts',
    data: Massachusts,
  },

  {
    title: '3',
    link: 'car-service-texas',
    data: Texas,
  },
  {
    title: '4',
    link: 'car-service-california',
    data: California,
  },
  {
    title: '5',
    link: 'car-service-new-jersey',
    data: Newjersey,
  },
  {
    title: '5',
    link: 'car-service-new-york',
    data: Newyork,
  },
  {
    title: '5',
    link: 'car-service-illinois',
    data: Illinois,
  },
  {
    title: '5',
    link: 'connecticut-car-service',
    data: ConnectiCut,
  },
  {
    title: '5',
    link: 'pennsylvania-car-service',
    data: Pennsylvania,
  },
  {
    title: '5',
    link: 'georgia-car-service',
    data: GeorGia,
  },
  {
    title: '5',
    link: 'colorado-car-service',
    data: ColoradoSt,
  },

  // ============airport page================

  {
    id: '1',
    link: 'miami-airport-car-service',
    data: Miami,
  },
  {
    id: '2',
    link: 'fort-lauderdale-airport-car-service',
    data: FortLauderdale,
  },
  {
    id: '3',
    link: 'tampa-airport-car-service',
    data: TampaInternational,
  },
  {
    id: '4',
    link: 'southwest-florida-airport-car-service',
    data: SouthWestFlorida,
  },
  {
    id: '5',
    link: 'orlando-airport-car-service',
    data: Orlando,
  },
  {
    id: '6',
    link: 'logan-airport-car-service',
    data: Logan,
  },
  {
    id: '7',
    link: 'love-field-dal-airport-car-service',
    data: DallasLove,
  },
  {
    id: '8',
    link: 'dallas-fort-worth-airport-car-service',
    data: DallasFortWorth,
  },
  {
    id: '9',
    link: 'fort-worth-alliance-airport-car-service',
    data: FortWorthalia,
  },

  {
    id: '10',
    link: 'dallas-executive-airport-car-service',
    data: dallasexecutive,
  },
  {
    id: '11',
    link: 'san-francisco-airport-car-service',
    data: SanFranciso,
  },

  {
    id: '12',
    link: 'oakland-airport-car-service',
    data: Oaklandairport,
  },
  {
    id: '13',
    link: 'san-jose-airport-car-service',
    data: SanJOse,
  },
  {
    id: '14',
    link: 'newark-ewr-airport-car-service',
    data: Newark,
  },

  {
    id: '15',
    link: 'jfk-airport-car-service',
    data: Jfkairport,
  },
  {
    id: '16',
    link: 'lga-airport-car-service',
    data: Lgaairport,
  },
  {
    id: '17',
    link: 'long-island-airport-car-service',
    data: LongIsland,
  },
  {
    id: '18',
    link: 'dca-airport-car-service',
    data: RonaldReagan,
  },
  {
    id: '19',
    link: 'dullas-airport-car-service',
    data: washingtonDulles,
  },
  {
    id: '19',
    link: 'baltimore-airport-car-service',
    data: Baltimore,
  },

  {
    id: '19',
    link: 'ohare-ord-airport-car-service',
    data: Ohare,
  },
  {
    id: '19',
    link: 'midway-mdw-airport-car-service',
    data: Midway,
  },

  {
    id: '19',
    link: 'bradley-airport-car-service',
    data: Bradly,
  },

  {
    id: '19',
    link: 'philadelphia-airport-car-service',
    data: PhiladelPhiaAirport,
  },

  {
    id: '19',
    link: 'atlanta-airport-car-service',
    data: HartField,
  },

  {
    id: '19',
    link: 'denver-airport-car-service',
    data: DenverAirport,
  },

  {
    id: '19',
    link: 'houston-airport-car-service',
    data: HoustonAirport,
  },

  {
    id: '19',
    link: 'austin-airport-car-service',
    data: AustinAirport,
  },

  // ================location cities page ============

  {
    id: '1',
    link: 'car-service-miami',
    data: CitiesMiami,
  },
  {
    id: '1',
    link: 'boston-car-service',
    data: CitiesBoston,
  },

  {
    id: '1',
    link: 'car-service-dallas',
    data: Citiesdallas,
  },
  {
    id: '1',
    link: 'car-service-orlando',
    data: Citieorlando,
  },

  {
    id: '1',
    link: 'car-service-fort-lauderdale',
    data: Citiesfort,
  },

  {
    id: '1',
    link: 'car-service-fort-worth',
    data: CitiesfortWorth,
  },
  {
    id: '1',
    link: 'car-service-san-francisco',
    data: Samfranciso,
  },
  {
    id: '1',
    link: 'car-service-jersey-city',
    data: JersyCity,
  },

  {
    id: '1',
    link: 'new-york-city-car-service',
    data: NewYork,
  },
  {
    id: '1',
    link: 'car-service-washington-dc',
    data: WashingtonCity,
  },
  {
    id: '1',
    link: 'car-service-chicago',
    data: chicagoCity,
  },
  {
    id: '1',
    link: 'car-service-hartford',
    data: HartFord,
  },
  {
    id: '1',
    link: 'car-service-philadelphia',
    data: PhiladelPhia,
  },
  {
    id: '1',
    link: 'car-service-atlanta',
    data: AtlantaCity,
  },
  {
    id: '1',
    link: 'car-service-fort-myers',
    data: FortMayers,
  },
  {
    id: '1',
    link: 'car-service-denver',
    data: DanverCity,
  },

  {
    id: '1',
    link: 'car-service-houston',
    data: Huston,
  },

  {
    id: '1',
    link: 'car-service-austin',
    data: AustinCity,
  },
  // ===============new city page==========
  // {
  //   id: "1",
  //   link: "car-service-aust",
  //   data: NewPage,
  // },
  // ===============services pages======
  {
    id: '1',
    link: 'airport-car-service',
    data: Carservice,
  },
  {
    id: '2',
    link: 'chauffeur-service',
    data: ChauffourServices,
  },
  {
    id: '3',
    link: 'city-to-city',
    data: CityToCity,
  },
  {
    id: '4',
    link: 'hourly-car-service',
    data: Hourlyhire,
  },
  {
    id: '5',
    link: 'point-to-point',
    data: PointtoPoint,
  },
  {
    id: '6',
    link: 'client-partner',
    data: ClientPartner,
  },
  {
    id: '6',
    link: 'corporate-events',
    data: CorprateEvent,
  },
  {
    id: '6',
    link: 'corporate-airport-transfer',
    data: CorprateAirport,
  },
  {
    id: '6',
    link: 'meetings-and-offsite-events',
    data: Meetingoffsite,
  },
  // ===================Routes page=======================

  // 5 Orlando Routes
  {
    id: '',
    link: 'route-orlando-disney-world',
    data: OrlandoDisneyWorld,
  },
  {
    id: '',
    link: 'route-orlando-tampa',
    data: OrlandoTampa,
  },
  {
    id: '',
    link: 'route-orlando-international-universal-studios',
    data: OrlandoUniversalStudio,
  },
  {
    id: '',
    link: 'route-orlando-international-port-canaveral',
    data: OrlandoPortCanaveral,
  },
  {
    id: '',
    link: 'route-palm-beach-orlando',
    data: OrlandoPalmBeach,
  },
  // 2 Miami Routes
  {
    id: '',
    link: 'route-miami-palm-beach',
    data: MiamiPalmBeach,
  },
  {
    id: '',
    link: 'route-miami-orlando',
    data: MiamiOrlando,
  },
  // 4 Fort Lauderdale Routes
  {
    id: '',
    link: 'route-fort-lauderdale-orlando',
    data: FortLauderdaleOrlando,
  },
  {
    id: '',
    link: 'route-miami-fort-lauderdale',
    data: MiamiFortLauderdale,
  },
  {
    id: '',
    link: 'route-fort-lauderdale-palm-beach',
    data: FortPalmBeach,
  },
  {
    id: '',
    link: 'route-fort-lauderdale-tampa',
    data: FortLauderdaleTampa,
  },
  // 7 Boston Routes
  {
    id: '',
    link: 'route-boston-new-york',
    data: BostonNewYork,
  },
  {
    id: '',
    link: 'route-boston-provincetown',
    data: BostonProvinceTown,
  },
  {
    id: '',
    link: 'route-new-haven-boston',
    data: NewHevanBoston,
  },
  {
    id: '',
    link: 'route-boston-cape-cod',
    data: BostonCapeCod,
  },
  {
    id: '',
    link: 'route-boston-hyannis',
    data: BostonHyannis,
  },
  {
    id: '',
    link: 'route-boston-barnstable',
    data: BostonBarnstable,
  },
  {
    id: '',
    link: 'route-boston-falmouth',
    data: BostonFalmouth,
  },
  // 1 Dallas Route
  {
    id: '',
    link: 'route-austin-dallas',
    data: AustinDallas,
  },
  // 2 San Franisco Routes
  {
    id: '',
    link: 'route-san-francisco-napa',
    data: SanFranciscoNapa,
  },
  {
    id: '',
    link: 'route-san-francisco-carmel',
    data: SanFranciscoCarmel,
  },
  // 1 Jersey City Route
  {
    id: '',
    link: 'route-new-york-atlantic-city',
    data: NewYorkAtlanticCity,
  },
  // 7 New York Routes
  {
    id: '',
    link: 'route-new-york-washington',
    data: NYCWashingtonDC,
  },
  {
    id: '',
    link: 'route-new-york-new-haven',
    data: NYCNewHaven,
  },
  {
    id: '',
    link: 'route-new-york-east-hampton',
    data: NYCEastHampton,
  },
  {
    id: '',
    link: 'route-new-york-montauk',
    data: NYCMontauk,
  },
  {
    id: '',
    link: 'route-new-york-greenwich-ct',
    data: NYCGreenwichCT,
  },
  {
    id: '',
    link: 'route-new-york-greenport',
    data: NYCGreenport,
  },
  {
    id: '',
    link: 'route-new-york-philadelphia',
    data: NYCPhiladelphia,
  },
  // 1 Washington DC Route
  {
    id: '',
    link: 'route-washington-dc-baltimore',
    data: WashingtonDCBaltimore,
  },
  // 1 Chicago Route
  {
    id: '',
    link: 'route-chicago-milwaukee',
    data: ChicagoMilwaukee,
  },
  // 1 Philadelphia Route
  {
    id: '',
    link: 'route-philadelphia-atlantic-city',
    data: PhiladelphiaAtlanticCity,
  },
  {
    id: '',
    link: 'route-nice-saint-tropez',
    data: SaintTropez,
  },
  {
    id: '',
    link: 'route-hartford-boston',
    data: HartFordBoston,
  },
  {
    id: '',
    link: 'route-atlanta-nashville',
    data: AltanticNadhvil,
  },
  {
    id: '',
    link: 'route-denver-vail',
    data: DenverVail,
  },
  {
    id: '',
    link: 'route-denver-copper-mountain',
    data: DenverCopper,
  },
  {
    id: '',
    link: 'route-denver-breckenridge',
    data: DenverBreck,
  },
  {
    id: '',
    link: 'route-denver-aspen',
    data: DenverAspen,
  },
  {
    id: '',
    link: 'route-denver-beaver-creek',
    data: DenverBeaver,
  },
  {
    id: '',
    link: 'route-denver-snowmass',
    data: DenverSnow,
  },
  {
    id: '',
    link: 'top-benefits-of-choosing-black-car-service',
    data: FirstBLog,
  },
  {
    id: '',
    link: 'safety-measures-in-private-airport-transfers',
    data: SecondtBLog,
  },
  {
    link: '/g/texas-car-service',
  },
];

export default statesPage;
